export default __webpack_public_path__ + "static/media/hht2_home_img_EP1.7f90e2ef.png";